export const TransfersAction = {
  UPDATE_ALIAS: '@TRANSFERS:UPDATE_ALIAS'
}
